import type { TaskPriority } from '@mybusinessmate/schema';
import { PRIORITY_KEY } from '../../lib/workbench-display';

// Full class names must appear literally for Tailwind to generate them.
const TONE = {
  high: { pill: 'bg-priority-high-bg text-priority-high-text', dot: 'bg-priority-high-dot' },
  medium: { pill: 'bg-priority-medium-bg text-priority-medium-text', dot: 'bg-priority-medium-dot' },
  low: { pill: 'bg-priority-low-bg text-priority-low-text', dot: 'bg-priority-low-dot' },
} as const;

/** Figma A05.7 "Priority": a dot and a word, High amber, Medium blue, Low grey. Never red. */
export function PriorityPill({ priority }: { priority: TaskPriority }) {
  const tone = TONE[PRIORITY_KEY[priority]];
  return (
    <span
      className={`inline-flex h-(--mbm-space-4) shrink-0 items-center gap-(--mbm-space-1) rounded-(--mbm-radius-xs) px-(--mbm-space-1-5) text-label-small ${tone.pill}`}
    >
      <span aria-hidden className={`size-(--mbm-space-1-5) rounded-full ${tone.dot}`} />
      {priority}
    </span>
  );
}
